import { operate } from '../util/lift';
import { createFind } from './find';
export function findIndex(predicate, thisArg) {
    return operate(createFind(predicate, thisArg, 'index'));
}
